/**
 * Lấy game type từ config string của account.
 * VD: "[XD] CHAN | CHAN:400K" → "XD". Không parse được thì trả "?".
 */
export function parseGameType(configStr: string | undefined): string {
  if (!configStr) return '?';
  const m = configStr.match(/^\[([A-Z]+)\]/);
  return m?.[1] ?? '?';
}
